import useBaType from "hooks/useBaType";
import { SentryRoute } from "index";
import React from "react";
import { useEffect } from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import { baType } from "types/baType";
import List from "./List";
import Show from "./Show";

const OneHrRouter = () => {
  useBaType([baType.CATEGORY1]);
  const location = useLocation();
  const match = useRouteMatch();

  useEffect(() => {
    document.body.classList.add("oneHr");

    return () => {
      document.body.classList.remove("oneHr");
    };
  }, []);

  return (
    <Switch location={location}>
      <SentryRoute exact path={`${match.path}/course/:id`} component={Show} />
      <SentryRoute path={`${match.path}/:code`} component={List} />
    </Switch>
  );
};

export default OneHrRouter;
